import React, { useEffect, useLayoutEffect, useState } from "react";

import VisibilityIcon from "@mui/icons-material/Visibility";

import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Box,
   
    Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
 
    useGetPendingCompanyQuery,
    
} from "../../services/users";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";

import Pagination from "../../components/Pagination";

import Loader from "../../helpers/constants/Loader";
import moment from "moment";





const ManageXmlOverview = () => {
    const navigate = useNavigate();
    const [type, setType] = useState<string>("");

    
    const [rows1, setRows1] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
  
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount1] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    let totalPages = Math.ceil(totalCount / limit);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
 
    const onPageChange = (newPage: number) => {
        setPage(newPage);
        setRows1([]);
    };
    const { state } = useLocation();
    const [value, setValue] = React.useState(0);

 

  

 


    const {
        data,
        isError,
        isSuccess,
        isLoading: load,
    } = useGetPendingCompanyQuery({
        page: page,
        search: debouncedSearchTerm?.trim(),
        limit: limit,
        isAdminAprooved: 2,
        agencyType: type ? type : "",
        range: {
            from: "",
            to: "",
        },
    });

  

 

 



  

    useLayoutEffect(() => {
        if (state) {
            setValue(state);
        }
    }, []);

    useEffect(() => {
        if (isSuccess && data) {
            const res = data?.data;
            setRows1(res?.user || []);
            setTotalCount1(res?.totalCount);
          
        }
    }, [isSuccess, data]);

    return (
        <div>
            <Loader isLoad={isLoading || load} />
            <div className="main_loyout">
                <div className="dashboard">
                    <h1 className="mn_hdng">Manage XML Overview</h1>
                </div>
                <Card className="cards">
                    <Box className="cards_header">


                       
                            <SearchBar2
                                value={searchTerm}
                                searchTerm={searchTerm}
                                onCross={() => setSearchTerm("")}
                                setDebouncedSearchTerm={setDebouncedSearchTerm}
                                onChange={(val: any) => {
                                    if (isValidInput(val.target.value)) {
                                        setSearchTerm(val.target.value);
                                        setTimeout(() => {
                                            setPage(1)
                                        }, 1000)
                                    }
                                }}
                            />

                          


                        </Box>
                   
                    <Box className="custom_tabs">
                        <TableContainer className="table_container">
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">S.No</TableCell>
                                        <TableCell align="center">Actions</TableCell>
                                        <TableCell>Company Id</TableCell>
                                        <TableCell>Image</TableCell>
                                        <TableCell>Company name</TableCell>
                                        <TableCell>Phone Number</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Document Status</TableCell>
                                        <TableCell>Date & time</TableCell>
                                        <TableCell>ORN</TableCell>
                                        <TableCell>Total Agent</TableCell>
                                        <TableCell>Total Properties</TableCell>
                                        <TableCell>Emirate Id</TableCell>
                                        <TableCell>Location</TableCell>
                                        <TableCell>Tokens</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows1?.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={8} align="center">
                                                No company found
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        rows1?.map((row: any, i: any) => (
                                            <TableRow key={row?._id}>
                                                <TableCell align="center">
                                                    {(page - 1) * 10 + i + 1}
                                                </TableCell>
                                                <TableCell>
                                                    <Box className="table_actions">
                                                        <Tooltip title="View Details">
                                                            <IconButton
                                                                onClick={() =>
                                                                    navigate(
                                                                        `/xml-overview-records/${row?._id}`,
                                                                        {
                                                                            state: { insights: true, tab: 1 },
                                                                        }
                                                                    )
                                                                }
                                                            >
                                                                <VisibilityIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                       
                                                       
                                                        
                                                    </Box>
                                                </TableCell>
                                                <TableCell>{row?.referenceId || "-"}</TableCell>

                                                <TableCell>
                                                    <figure
                                                        className="user_img"
                                                    >
                                                        <img
                                                            src={row?.image || "/static/images/picture.png"}
                                                            alt=""
                                                        />
                                                    </figure>
                                                </TableCell>
                                                <TableCell>{row?.companyName || "-"}</TableCell>
                                                <TableCell>
                                                    {row?.phoneNo ? row?.dialCode + row?.phoneNo : "-"}
                                                </TableCell>
                                                <TableCell>{row?.email || "-"}</TableCell>
                                                <TableCell align="center" >{row?.isDocumentUploaded ? (
                                                    <img
                                                        width="30px"
                                                        src="/static/images/check.png"
                                                        alt="uploaded"
                                                    />
                                                ) : ("")}</TableCell>
                                                <TableCell>{row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}</TableCell>
                                                <TableCell>{row?.ORN || "-"}</TableCell>
                                                <TableCell>{row?.totalAgents || "-"}</TableCell>
                                                <TableCell>{row?.totalProperties || "0"}</TableCell>
                                                <TableCell>{row?.emiratesId || "-"}</TableCell>
                                                <TableCell>{row?.address || "-"}</TableCell>
                                                <TableCell>{row?.token || "-"}</TableCell>

                                               

                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {rows1?.length > 0 ? (
                            <Pagination
                                setPage={setPage}
                                limit={limit}
                                setLimit={setLimit}
                                module={rows1}
                                page={page}
                                onPageChange={onPageChange}
                                totalPages={totalPages}
                            />
                        ) : (
                            ""
                        )}
                       


                    </Box>
               
                

                </Card>
            </div>
        </div >
    );
};

export default ManageXmlOverview;
